module.exports = __webpack_public_path__ + "img/edu-lauton-TyQ-0lPp6e4-unsplash.54584532.jpg";